import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { IClient, TreatmentsWithConfig, Attributes } from "@splitsoftware/splitio/types/splitio";
import { useAuthStore } from "@/store/AuthStore";
import SplitAdapter from "@/split-adapter";
import FEATURE_FLAGS from "@/split-adapter/feature-flags";

const useFeatureFlagsStore = defineStore("feature-flags", () => {
  const userStore = useAuthStore();

  const splitIoClient = ref<IClient | null>(null);
  const treatments = ref<TreatmentsWithConfig>({});

  const userEmail = computed(() => userStore.loggedInUser?.email);

  const setTreatments = async (attributes: Attributes = {}) => {
    if (!splitIoClient.value) return [];
    await splitIoClient.value.ready();
    treatments.value = SplitAdapter.treatments(splitIoClient.value, Object.values(FEATURE_FLAGS), attributes);
    return treatments;
  };

  const isOn = (feature: string) => treatments.value?.[feature]?.treatment === "on";

  const initializeClient = async (key: string) => {
    splitIoClient.value = await SplitAdapter.create(key);
    return await setTreatments();
  };

  const switchClient = async (key: string) => {
    splitIoClient.value && (await SplitAdapter.destroy(splitIoClient.value));
    splitIoClient.value = null;
    return await initializeClient(key);
  };

  watch(userEmail, () => switchClient(userEmail.value));

  initializeClient(userEmail.value);

  return {
    treatments,
    setTreatments,
    isOn,
  };
});

export default useFeatureFlagsStore;
